CollectionView = require 'app/scripts/views/internal/collection-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
InlineListComposerView = require 'app/scripts/views/list/inline-list-composer-view'
ListView = require 'app/scripts/views/list/list-view'
assert = require 'app/scripts/lib/assert'

module.exports = class ListListView extends CollectionView
  viewType: ListView

  initialize: ({ @resetCallback }) ->
    super

    assert @resetCallback?

    @listenTo @collection,
      'reset': @resetCallback
      'change:idBoard': @boardChange

  render: ->
    maxVisibleLists = Math.max(3, Math.ceil(window.innerWidth / 270)) # Hard coded list width

    subviews = @getModels().map (model, index) =>
      @subview @viewType, model, { deferCards: index >= maxVisibleLists }

    if @model.editable()
      subviews.push @subview InlineListComposerView, @model

    @ensureSubviews(subviews)
    @resetCallback()

  boardChange: (list, idBoard) ->
    if idBoard == @collection.board.get('id') then return
    @collection.remove(list)
    DragSort.refreshIfInitialized(@$el)

  addModel: ->
    super
    @resetCallback()

  removeSubview: ->
    super
    DragSort.refreshListCardSortable()
    return

  insertSubview: (subview) ->
    super
    if(subview.$el.find('.ui-sortable').length > 0)
      DragSort.refreshIfInitialized(@$el)
    else
      DragSort.refreshListCardSortable()
    return
